import { NOTIFICATION_UPDATE } from '../constants/actionTypes.js'

const initialState = {
  notificationOpen: true,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_UPDATE:
      return Object.assign({}, state, action)
    default:
      return state
  }
}

export default reducer
export { initialState }
